import type { IStyles } from '@wix/tpa-settings';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import settingsParams, {
  uninitializedVisibilitySettingsTrueValue,
} from '../settingsParams';
import { VisibilityKey } from './types';

let stylesForAllBreakpoints: IStyles[] | undefined;

export function resetStylesCache() {
  stylesForAllBreakpoints = undefined;
}

export function useCachedStyles() {
  const { isEditor } = useEnvironment();
  const styles = useStyles();

  return {
    getStylesForAllBreakpoints() {
      if (!stylesForAllBreakpoints || isEditor) { // in editor, style might change, so we must re-get the styles on every call
        stylesForAllBreakpoints = styles.getStylesForAllBreakpoints();
      }

      return stylesForAllBreakpoints;
    },
  };
}

export function useVisibilityCheck() {
  const settings = useSettings();
  const { isCssPerBreakpoint } = useEnvironment();
  const { getStylesForAllBreakpoints } = useCachedStyles();

  return {
    shouldBeVisible(key: VisibilityKey) {
      const settingsValue = settings.get(settingsParams[key]);
      if (isCssPerBreakpoint) {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : getStylesForAllBreakpoints().some(({ booleans }) => booleans[key]);
      } else {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : settingsValue === uninitializedVisibilitySettingsTrueValue;
      }
    },
  };
}
